import { Routes, Route, Navigate } from "react-router-dom";
import InfoLayout from "components/InfoLayout";
import Sidebar from "./_components/SideBar";
import InfoPage from "../../views/settings/InfoPage";
import ModelPage from "../../views/settings/ModelPage";
import ModelAssignmentPage from "../../views/settings/ModelAssignmentPage";
import { useTranslation } from "react-i18next";

interface SettingsLayoutProps {
  settingsType: "global" | "organization";
  basePath: string;
}

const SettingsLayout: React.FC<SettingsLayoutProps> = ({ settingsType, basePath }) => {
  const { t } = useTranslation();
  const isGlobal = settingsType === "global";
  const titlePrefix = isGlobal ? t("settings.global") : t("settings.organization");
  
  const HEADER_MAP = {
    "/": {
      title: t("settings.header.info.title", { type: titlePrefix }),
      subtitle: t("settings.manageSettings", { type: settingsType }),
    },
    "/model": {
      title: t("settings.header.model.title", { type: titlePrefix }), 
      subtitle: t("settings.manageModels", { type: settingsType }),
    },
    "/model-assignment": {
      title: t("settings.header.modelAssignment.title", { type: titlePrefix }),
      subtitle: t("settings.configureAssignments", { type: settingsType }),
    },
  };

  const getSettingsHeaderKey = (location: any): string => {
    const path = location.pathname.replace(basePath, "");
    return path === "" ? "/" : `/${path}`;
  };

  return (
    <InfoLayout
      Sidebar={() => <Sidebar settingsType={settingsType} basePath={basePath} />}
      headerMap={HEADER_MAP}
      getHeaderKey={getSettingsHeaderKey}
    >
      <Routes>
        <Route path="/" element={<InfoPage settingsType={settingsType} />} />
        <Route path="/model" element={<ModelPage settingsType={settingsType} />} />
        <Route path="/model-assignment" element={<ModelAssignmentPage settingsType={settingsType} />} />
        <Route path="*" element={<Navigate to={basePath} />} />
      </Routes>
    </InfoLayout>
  );
};

export default SettingsLayout;
